import './ActionTile.scss';

interface Props {
  icon: string;
  title?: string;
  subtitle?: string;
  onClick: () => void;
}

export const ActionTile = (props: Props) => {
  const { onClick, title, subtitle } = props;

  return (
    <div className={'w-100 d-flex flex-wrap justify-content-center p-3 tile-button__wrapper'} onClick={onClick}>
      <div className='tile-button__button d-flex align-items-center justify-content-center border border-ThemeBorderDefault p-2 rounded'>
        <i className={`text-lg text-ThemeTextMedium fa ${props.icon}`} />
      </div>
      {title || subtitle ? (
        <div className='w-100 mt-1 text-center text-ThemeTextMedium'>
          <div className='mt-2 text-md'>
            <h5>{title}</h5>
            <div>{subtitle}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
